<Navbar />
<div class="aic-one-console aic-mobile-page aic-dashboard-page">
  <div class="page-wrapper aic-mobile-content">
    <Sidebar />

    <div class="hero-section w-100 soft-card aic-safe-bottom">
      <section class="dashboard-mode-card card border-0 rounded-4 shadow-lg mb-4 d-none d-lg-block">
        <div class="card-body p-3 p-md-4">
          <div class="d-flex flex-column flex-xxl-row align-items-start align-items-xxl-center justify-content-xxl-between gap-3">
            <div v-if="active_dashboard_mode === 'my'" class="d-none d-md-block">
              <h4 class="dashboard-greeting-title mb-0 text-start">
                <span class="dashboard-greeting-lead">{{ dashboard_greeting }}, {{ user_first_name }}</span>
                <span class="dashboard-greeting-separator" aria-hidden="true">-</span>
                <span class="dashboard-greeting-summary">{{ dashboard_summary }}.</span>
              </h4>
            </div>

            <div v-if="active_dashboard_mode === 'executive'">
              <h4 class="fw-semibold mb-1 text-start">{{ user.name }} - Executive Dashboard</h4>
              <p class="text-muted mb-0">High-level insights across products, revenue and organizational health</p>
            </div>

            <div v-if="active_dashboard_mode === 'team'">
              <h4 class="fw-semibold mb-1 text-start">{{ user.name }} - Team Performance Dashboard</h4>
              <p class="text-muted mb-0">{{ team_data.name }} - Team Lead: {{ team_data.lead }}</p>
            </div>

            <div class="d-flex flex-wrap justify-content-center justify-content-lg-end gap-2 w-100 w-xxl-auto">
              <button
                v-if="can_view_my_dashboard"
                class="overview-btn"
                :class="{ active: active_dashboard_mode === 'my' }"
                @click="set_dashboard_mode('my')"
                title="Personal dashboard with your tasks and activities"
              >
                <i class="fa-solid fa-user me-1"></i>
                My Overview
              </button>

              <button
                v-if="can_view_team_dashboard"
                class="overview-btn"
                :class="{ active: active_dashboard_mode === 'team' }"
                @click="set_dashboard_mode('team')"
                title="Team performance metrics and collaboration"
              >
                <i class="fa-solid fa-users me-1"></i>
                Team Overview
              </button>

              <button
                v-if="can_view_executive_dashboard"
                class="overview-btn"
                :class="{ active: active_dashboard_mode === 'executive' }"
                @click="set_dashboard_mode('executive')"
                title="Executive-level insights and analytics"
              >
                <i class="fa-solid fa-chart-line me-1"></i>
                Executive Overview
              </button>
            </div>
          </div>

          <div v-if="active_dashboard_mode === 'executive'" class="row g-3 mt-3">
            <div class="col-12 col-sm-6 col-lg-3" v-for="kpi in executive_kpis" :key="kpi.label">
              <div class="card h-100 border-0 rounded-4 shadow-sm">
                <div class="card-body p-3">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">{{ kpi.label }}</span>
                    <i :class="kpi.icon" :style="{color: kpi.color}"></i>
                  </div>
                  <div class="h4 fw-bold mb-0">{{ kpi.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="active_dashboard_mode === 'team'" class="row g-3 mt-3 d-none d-lg-flex">
            <div class="col-lg-3" v-for="metric in key_metrics" :key="metric.label">
              <div class="card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-danger">
                <div class="card-body p-3">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">{{ metric.label }}</span>
                    <i :class="metric.icon" :style="{ color: metric.color }"></i>
                  </div>
                  <div class="h4 fw-bold mb-0">{{ metric.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="active_dashboard_mode === 'my'" class="row g-3 mt-3 d-none d-lg-flex">
            <div class="col-lg-3" v-for="metric in desktop_top_metrics" :key="metric.label">
              <div class="card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-danger">
                <div class="card-body p-3">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted small">{{ metric.label }}</span>
                    <i :class="metric.icon" :style="{color: metric.color}"></i>
                  </div>
                  <div class="h4 fw-bold mb-0">{{ metric.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="dashboard-mobile-controls d-lg-none mx-auto w-100 mb-3">
        <div class="d-flex justify-content-start gap-2 mb-3">
          <button
            v-if="can_view_my_dashboard"
            class="overview-btn"
            :class="{ active: active_dashboard_mode === 'my' }"
            @click="set_dashboard_mode('my')"
            title="Personal dashboard with your tasks and activities"
          >
            <i class="fa-solid fa-user me-1"></i>
            My Overview
          </button>

          <button
            v-if="can_view_team_dashboard"
            class="overview-btn"
            :class="{ active: active_dashboard_mode === 'team' }"
            @click="set_dashboard_mode('team')"
            title="Team performance metrics and collaboration"
          >
            <i class="fa-solid fa-users me-1"></i>
            Team
          </button>

          <button
            v-if="can_view_executive_dashboard"
            class="overview-btn"
            :class="{ active: active_dashboard_mode === 'executive' }"
            @click="set_dashboard_mode('executive')"
            title="Executive-level insights and analytics"
          >
            <i class="fa-solid fa-chart-line me-1"></i>
            Executive
          </button>
        </div>

        <div v-if="active_dashboard_mode === 'my'" class="row g-2">
          <div class="col-6 col-md-3" v-for="metric in mobile_top_metrics" :key="metric.label">
            <div class="dashboard-mobile-stat-card card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-danger">
              <div class="card-body p-3 text-start">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-2">
                  <span class="dashboard-mobile-stat-label text-muted small">{{ metric.short_label }}</span>
                  <i :class="metric.icon" :style="{color: metric.color}"></i>
                </div>
                <div class="h4 fw-bold mb-0">{{ metric.value }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="active_dashboard_mode === 'team'" class="row g-2">
          <div class="col-6 col-md-3" v-for="metric in mobile_team_metrics" :key="metric.label">
            <div class="dashboard-mobile-stat-card card h-100 border-0 rounded-4 shadow-lg border-top border-3 border-danger">
              <div class="card-body p-3 text-start">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-2">
                  <span class="dashboard-mobile-stat-label text-muted small">{{ metric.short_label }}</span>
                  <i :class="metric.icon" :style="{color: metric.color}"></i>
                </div>
                <div class="h4 fw-bold mb-0">{{ metric.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div v-if="active_dashboard_mode === 'team'" class="team-dashboard">
        <TeamDashboard />
      </div>

      <div v-if="active_dashboard_mode === 'executive'" class="executive-wrapper">
        <ExecutiveDashboard />
      </div>

      <div v-if="active_dashboard_mode === 'my'" class="row g-3 d-none d-lg-flex">
        <div class="col-lg-3">
          <div class="card border-0 rounded-4 shadow-lg h-100 cursor-pointer" @click="go_to_page('/drive')">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">Personal Storage</h6>
                <i class="fa-solid fa-database text-purple"></i>
              </div>
              <div class="mb-2">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <span class="h5 fw-bold mb-0">{{ used_gb || 0 }} GB</span>
                  <span class="text-muted small">of {{ total_gb || 5 }} GB</span>
                </div>
                <div class="progress progress-storage">
                  <div
                    class="progress-bar bg-dark storage-bar"
                    role="progressbar"
                    ref="storage_progress_bar"
                    :aria-valuenow="percentage_used || 0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="text-muted small mt-2">{{ available_gb || 0 }} GB available</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="card border-0 rounded-4 shadow-lg h-100">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">System Health</h6>
                <i class="fa-solid fa-heartbeat text-success"></i>
              </div>
              <div class="d-flex align-items-center gap-2 mb-3">
                <i class="fa-solid fa-circle-check text-success"></i>
                <span class="fw-semibold">All Systems Operational</span>
              </div>
              <div class="mb-2">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Performance</span>
                  <span class="small fw-semibold">98%</span>
                </div>
                <div class="progress mb-3 performance-bar">
                  <div class="progress-bar bg-success w-100"></div>
                </div>
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Uptime</span>
                  <span class="small fw-semibold">99.9%</span>
                </div>
                <div class="progress performance-bar">
                  <div class="progress-bar bg-dark w-100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card border-0 rounded-4 shadow-lg h-100">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">IC Workbook</h6>
                <img :src="cardImages.engagenet" alt="IC Workbook" class="icon-32 object-fit-contain" />
              </div>
              <div class="d-flex flex-column gap-3">
                <div class="d-flex align-items-start gap-3">
                  <div class="rounded-circle d-flex align-items-center justify-content-center icon-32 bg-white">
                    <i class="fa-solid fa-calendar text-primary small"></i>
                  </div>
                  <div class="flex-grow-1 min-w-0">
                    <div class="fw-semibold small">Upcoming Events</div>
                    <div v-if="upcoming_events.length > 0" class="text-muted custom-font text-truncate">
                      Next: {{ upcoming_events[0].event_name }} ({{ upcoming_events[0].start_date }})
                    </div>
                    <div v-else class="text-muted custom-font">No upcoming events</div>
                  </div>
                  <span class="badge rounded-pill bg-white text-dark">{{ upcoming_events.length }}</span>
                </div>
                <div class="d-flex align-items-start gap-3">
                  <div class="rounded-circle d-flex align-items-center justify-content-center icon-32 bg-white">
                    <i class="fa-solid fa-file-alt text-purple small"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="fw-semibold small">Document Approvals</div>
                    <div class="text-muted custom-font">Requires your approval</div>
                  </div>
                  <span class="badge rounded-pill bg-white text-dark">{{ pending_approvals }}</span>
                </div>
                <div class="d-flex align-items-start gap-3">
                  <div class="rounded-circle d-flex align-items-center justify-content-center icon-32 bg-white">
                    <i class="fa-solid fa-bell text-success small"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="fw-semibold small">New Updates</div>
                    <div class="text-muted custom-font">Policy changes & announcements</div>
                  </div>
                  <span class="badge rounded-pill bg-white text-dark">{{ notification_count }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card border-0 rounded-4 shadow-lg h-100">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">Tasks Assigned to You</h6>
                <i class="fa-solid fa-tasks"></i>
              </div>
              <div class="d-flex gap-3 mb-3">
                <div class="d-flex align-items-center gap-2">
                  <i class="fa-regular fa-clock text-primary"></i>
                  <span class="small">{{ assigned_tasks_count }} Assigned</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <i class="fa-solid fa-exclamation-triangle text-danger"></i>
                  <span class="small">{{ overdue_tasks_count }} Overdue</span>
                </div>
              </div>

              <div v-if="tasks_loading" class="text-center py-4">
                <div class="spinner-border text-primary"></div>
              </div>
              <div v-else-if="tasks.length === 0" class="text-center py-4">
                <i class="fa-solid fa-clipboard-list fa-2x text-muted"></i>
                <p class="text-muted mt-2 mb-0">No tasks assigned</p>
              </div>
              <div v-else class="d-flex flex-column gap-3">
                <div v-for="task in tasks.slice(0, 3)" :key="task.id" class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                  <div class="flex-grow-1 min-w-0">
                    <div class="fw-semibold small text-truncate">{{ task.title }}</div>
                    <div class="text-muted custom-font text-truncate">
                      {{ task.platform_name }}
                      <span v-if="task.due_date"> - Due {{ task.due_date }}</span>
                    </div>
                  </div>
                  <span class="badge flex-shrink-0" :class="status_badge_class(task.status)">
                    {{ format_status(task.status) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card border-0 rounded-4 shadow-lg h-100">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">Courses & Learning</h6>
                <img :src="cardImages.orcaa" alt="Orcaa" class="icon-32 object-fit-contain" />
              </div>

              <div v-if="courses_loading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading courses...</span>
                </div>
                <p class="text-muted small mt-2">Loading your courses...</p>
              </div>
              <div v-else-if="!courses || courses.length === 0" class="text-center py-4">
                <i class="fa-solid fa-book-open fa-2x text-muted mb-3"></i>
                <p class="text-muted">No courses enrolled yet</p>
              </div>
              <div v-else class="d-flex flex-column gap-3">
                <div v-for="course in courses.slice(0, 3)" :key="course.id">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div class="fw-semibold small flex-grow-1 min-w-0 text-truncate">{{ course.course_name }}</div>
                    <span v-if="course.course_price === '0' || course.course_price === '0.00'" class="badge rounded-pill bg-success text-white ms-2">Free</span>
                    <span v-else class="badge rounded-pill bg-primary text-white ms-2">R{{ course.course_price }}</span>
                  </div>
                  <div class="text-muted custom-font small overflow-hidden text-truncate mb-2">{{ course.course_overview }}</div>
                  <div class="d-flex align-items-center gap-2">
                    <span class="small text-muted">Status:</span>
                    <span class="badge rounded-pill" :class="course_status_badge_class(course.status)">{{ course.status }}</span>
                  </div>
                </div>

                <div class="d-flex justify-content-center mt-2 pt-3 border-top">
                  <div class="text-center">
                    <div class="h5 fw-bold mb-0">{{ courses.length }}</div>
                    <div class="text-muted small">Total Courses</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card border-0 rounded-4 shadow-lg h-100">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">Ongoing Cases</h6>
                <img :src="cardImages.xverdict" alt="X-Verdict" class="icon-32 object-fit-contain" />
              </div>
              <div v-if="cases_loading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
              <div v-else-if="!cases || cases.length === 0" class="text-center py-4">
                <i class="fa-solid fa-scale-balanced fa-2x text-muted mb-3"></i>
                <p class="text-muted mb-0">No ongoing cases</p>
              </div>
              <div v-else class="d-flex flex-column gap-3">
                <div v-for="case_item in cases.slice(0, 3)" :key="case_item.id || case_item.case_id || case_item.reference" class="d-flex align-items-center justify-content-between p-2 rounded bg-light">
                  <div class="flex-grow-1 min-w-0">
                    <div class="fw-semibold small text-truncate">{{ case_title(case_item) }}</div>
                    <div class="text-muted custom-font text-truncate">{{ case_date(case_item) }}</div>
                  </div>
                  <span class="badge rounded-pill bg-white text-dark flex-shrink-0">{{ format_status(case_status(case_item)) }}</span>
                </div>
                <div class="d-flex justify-content-around mt-2 pt-2 border-top">
                  <div class="text-center">
                    <div class="h5 fw-bold mb-0">{{ pending_cases }}</div>
                    <div class="text-muted small">Total Cases</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card border-0 rounded-4 shadow-lg h-100">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center gap-2">
                  <h6 class="mb-0 fw-semibold">Pending Requests</h6>
                  <span class="badge rounded-pill request-card">{{ pending_requests }}</span>
                </div>
                <img :src="cardImages.complyon" alt="ComplyOn" class="icon-32 object-fit-contain" />
              </div>

              <div v-if="pending_requests_loading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading requests...</span>
                </div>
                <p class="text-muted small mt-2">Loading your pending requests...</p>
              </div>
              <div v-else-if="!pending_requests_list || pending_requests_list.length === 0" class="text-center py-5">
                <i class="fa-regular fa-circle-check text-success fa-2x"></i>
                <p class="text-muted mt-3 mb-0">No pending requests</p>
              </div>
              <div v-else class="d-flex flex-column gap-3">
                <div v-for="request in pending_requests_list.slice(0, 3)" :key="request.id" class="p-3 rounded-3 bg-light position-relative">
                  <span class="badge bg-warning text-dark position-absolute top-0 end-0 m-2">Pending</span>
                  <p class="mb-3 pe-5 fw-medium text-dark">{{ request.message }}</p>
                  <div v-if="request.requested_fields && request.requested_fields.length > 0" class="mb-3">
                    <div v-for="field in request.requested_fields" :key="field.requested_field_id" class="d-flex align-items-start gap-2 mb-2 ps-2">
                      <i class="fa-solid fa-file-circle-exclamation text-warning mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="small text-muted">{{ field.form_section_name }}</div>
                        <div class="small fw-medium text-dark">{{ field.requested_field_text }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-2 text-muted small">
                    <i class="fa-regular fa-clock"></i>
                    <span>{{ format_date(request.date_created) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 d-none">
          <div class="card border-0 rounded-4 shadow-lg">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="mb-0 fw-semibold">My Activity Log</h6>
                <i class="fa-solid fa-history"></i>
              </div>

              <div v-if="audits_loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading activity...</span>
                </div>
                <p class="text-muted small mt-2">Loading your activity log...</p>
              </div>
              <div v-else-if="!has_audit_permission" class="text-center py-5">
                <i class="fa-solid fa-lock text-muted fa-2x mb-3"></i>
                <p class="text-muted mb-0">No permission to view activity log</p>
              </div>
              <div v-else-if="!audits || audits.length === 0" class="text-center py-5">
                <i class="fa-solid fa-history text-muted fa-2x mb-3"></i>
                <p class="text-muted mb-0">No recent activity</p>
              </div>
              <div v-else class="table-responsive dashboard-activity-log">
                <table class="table table-hover align-middle mb-0 dashboard-activity-table">
                  <thead class="table-light">
                    <tr>
                      <th class="border-0 small">Action</th>
                      <th class="border-0 small">Timestamp</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(log, idx) in recent_from_audits" :key="idx" class="dashboard-activity-row">
                      <td class="dashboard-activity-action-cell">
                        <div class="d-flex align-items-center gap-3">
                          <div class="activity-chip d-inline-flex align-items-center justify-content-center">
                            <img src="@/assets/aicone.png" class="img-fluid w-50 h-75" alt="" />
                          </div>
                          <span class="small dashboard-activity-message">{{ log.d }}</span>
                        </div>
                      </td>
                      <td class="text-muted small dashboard-activity-time">{{ log.t }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="active_dashboard_mode === 'my'" class="dashboard-mobile-stack d-flex d-lg-none flex-column gap-3 mx-auto w-100">
        <section>
          <h6 class="dashboard-section-title mb-2">Continue Where You Left Off</h6>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <div class="card border rounded-4 shadow-sm h-100">
                <div class="card-body p-3 text-start">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                    <div class="d-flex align-items-center gap-2 min-w-0">
                      <img :src="cardImages.orcaa" alt="Orcaa" class="icon-32 object-fit-contain" />
                      <h6 class="fw-bold mb-0 text-truncate">Courses & Learning</h6>
                    </div>
                    <span class="badge rounded-pill bg-light text-dark">{{ courses.length || 0 }}</span>
                  </div>

                  <div v-if="courses_loading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading courses...</span>
                    </div>
                    <p class="text-muted small mt-2 mb-0">Loading your courses...</p>
                  </div>

                  <div v-else-if="!courses || courses.length === 0" class="text-center py-4">
                    <i class="fa-solid fa-book-open fa-2x text-muted mb-3"></i>
                    <p class="text-muted mb-0">No courses enrolled yet</p>
                  </div>

                  <div v-else class="d-flex flex-column">
                    <div v-for="course in courses.slice(0, 3)" :key="course.id" class="dashboard-list-row py-2 border-bottom">
                      <div class="d-flex justify-content-between align-items-start gap-2 mb-1">
                        <div class="fw-semibold small min-w-0 text-truncate">{{ course.course_name }}</div>
                        <span v-if="course.course_price === '0' || course.course_price === '0.00'" class="badge rounded-pill bg-success text-white flex-shrink-0">Free</span>
                        <span v-else class="badge rounded-pill bg-primary text-white flex-shrink-0">R{{ course.course_price }}</span>
                      </div>
                      <div class="text-muted custom-font text-truncate mb-1">{{ course.course_overview }}</div>
                      <span class="badge rounded-pill" :class="course_status_badge_class(course.status)">{{ course.status }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="card border rounded-4 shadow-sm h-100">
                <div class="card-body p-3 text-start">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                    <div class="d-flex align-items-center gap-2 min-w-0">
                      <img :src="cardImages.xverdict" alt="X-Verdict" class="icon-32 object-fit-contain" />
                      <h6 class="fw-bold mb-0 text-truncate">Ongoing Cases</h6>
                    </div>
                    <span class="badge rounded-pill bg-light text-dark">{{ pending_cases }}</span>
                  </div>

                  <div v-if="cases_loading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status"></div>
                  </div>

                  <div v-else-if="!cases || cases.length === 0" class="text-center py-4">
                    <i class="fa-solid fa-scale-balanced fa-2x text-muted mb-3"></i>
                    <p class="text-muted mb-0">No ongoing cases</p>
                  </div>

                  <div v-else class="d-flex flex-column">
                    <div v-for="case_item in cases.slice(0, 3)" :key="case_item.id || case_item.case_id || case_item.reference" class="dashboard-list-row d-flex align-items-start justify-content-between gap-3 py-2 border-bottom">
                      <div class="min-w-0">
                        <div class="fw-semibold small text-truncate">{{ case_title(case_item) }}</div>
                        <div class="text-muted custom-font text-truncate">{{ case_date(case_item) }}</div>
                      </div>
                      <span class="badge rounded-pill bg-light text-dark flex-shrink-0">{{ format_status(case_status(case_item)) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card border rounded-4 shadow-sm">
                <div class="card-body p-3 text-start">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                    <div class="d-flex align-items-center gap-2 min-w-0">
                      <img :src="cardImages.complyon" alt="ComplyOn" class="icon-32 object-fit-contain" />
                      <h6 class="fw-bold mb-0 text-truncate">Pending Requests</h6>
                    </div>
                    <span class="badge rounded-pill request-card">{{ pending_requests }}</span>
                  </div>

                  <div v-if="pending_requests_loading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading requests...</span>
                    </div>
                    <p class="text-muted small mt-2 mb-0">Loading your pending requests...</p>
                  </div>

                  <div v-else-if="!pending_requests_list || pending_requests_list.length === 0" class="text-center py-4">
                    <i class="fa-regular fa-circle-check text-success fa-2x"></i>
                    <p class="text-muted mt-3 mb-0">No pending requests</p>
                  </div>

                  <div v-else class="d-flex flex-column gap-2">
                    <div v-for="request in pending_requests_list.slice(0, 3)" :key="request.id" class="dashboard-request-card p-3 rounded-3 bg-light">
                      <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                        <p class="mb-0 fw-medium small min-w-0">{{ request.message }}</p>
                        <span class="badge bg-warning text-dark flex-shrink-0">Pending</span>
                      </div>

                      <div v-if="request.requested_fields && request.requested_fields.length > 0" class="d-flex flex-column gap-2 mb-2">
                        <div v-for="field in request.requested_fields" :key="field.requested_field_id" class="d-flex align-items-start gap-2">
                          <i class="fa-solid fa-file-circle-exclamation text-warning mt-1"></i>
                          <div class="min-w-0">
                            <div class="small text-muted">{{ field.form_section_name }}</div>
                            <div class="small fw-medium text-dark">{{ field.requested_field_text }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex align-items-center gap-2 text-muted small">
                        <i class="fa-regular fa-clock"></i>
                        <span>{{ format_date(request.date_created) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h6 class="dashboard-section-title mb-2">Your Workspace</h6>
          <div class="row g-3 align-items-stretch">
            <div class="col-12 col-md-6">
              <div class="card border rounded-4 shadow-sm overflow-hidden h-100">
            <div class="card-body p-0">
              <div class="d-flex align-items-center justify-content-between gap-2 p-3 border-bottom">
                <div class="d-flex align-items-center gap-2 min-w-0">
                  <span class="dashboard-icon-soft d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0">
                    <i class="fa-solid fa-clipboard-list small text-danger"></i>
                  </span>
                  <h6 class="fw-bold mb-0 text-truncate">Tasks Assigned to You</h6>
                </div>
                <span class="badge rounded-pill bg-light text-dark">{{ assigned_tasks_count }}</span>
              </div>

              <div class="d-flex flex-wrap align-items-center gap-3 px-3 py-2 border-bottom">
                <span class="small text-muted"><i class="fa-regular fa-clock me-1"></i>{{ assigned_tasks_count }} Assigned</span>
                <span class="small fw-semibold text-danger"><i class="fa-solid fa-triangle-exclamation me-1"></i>{{ overdue_tasks_count }} Overdue</span>
                <span class="small text-muted"><i class="fa-solid fa-circle-check me-1"></i>{{ completed_this_week }} Completed</span>
              </div>

              <div v-if="tasks_loading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status"></div>
              </div>

              <div v-else-if="tasks.length === 0" class="text-center py-4 px-3">
                <i class="fa-solid fa-clipboard-list fa-2x text-muted"></i>
                <p class="text-muted mt-2 mb-0">No tasks assigned</p>
              </div>

              <div v-else class="d-flex flex-column">
                <div
                  v-for="task in tasks.slice(0, 3)"
                  :key="task.id"
                  class="dashboard-list-row d-flex align-items-start justify-content-between gap-3 p-3 border-bottom"
                >
                  <div class="min-w-0">
                    <div class="fw-semibold small text-truncate">{{ task.title }}</div>
                    <div class="text-muted custom-font text-truncate">
                      {{ task.platform_name }}
                      <span v-if="task.due_date"> - Due {{ task.due_date }}</span>
                    </div>
                  </div>
                  <span class="badge rounded-pill flex-shrink-0" :class="status_badge_class(task.status)">
                    {{ format_status(task.status) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card border rounded-4 shadow-sm overflow-hidden h-100">
                <div class="card-body p-0">
                  <div class="d-flex align-items-center gap-2 p-3 border-bottom">
                    <img :src="cardImages.engagenet" alt="IC Workbook" class="icon-32 object-fit-contain" />
                    <h6 class="fw-bold mb-0">IC Workbook</h6>
                  </div>

                  <div class="dashboard-list-row d-flex align-items-start gap-3 p-3 border-bottom text-start">
                    <span class="dashboard-icon-soft d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0">
                      <i class="fa-solid fa-file-alt text-purple small"></i>
                    </span>
                    <div class="min-w-0 flex-grow-1">
                      <div class="fw-semibold small">Document Approvals</div>
                      <div class="text-muted custom-font">Requires your approval</div>
                    </div>
                    <span class="fw-bold align-self-center">{{ pending_approvals }}</span>
                  </div>

                  <div class="dashboard-list-row d-flex align-items-start gap-3 p-3 border-bottom text-start">
                    <span class="dashboard-icon-soft d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0">
                      <i class="fa-solid fa-bell text-success small"></i>
                    </span>
                    <div class="min-w-0 flex-grow-1">
                      <div class="fw-semibold small">New Updates</div>
                      <div class="text-muted custom-font">Policy changes & announcements</div>
                    </div>
                    <span class="fw-bold align-self-center">{{ notification_count }}</span>
                  </div>

                  <div class="dashboard-list-row d-flex align-items-start gap-3 p-3 text-start">
                    <span class="dashboard-icon-soft d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0">
                      <i class="fa-solid fa-calendar text-primary small"></i>
                    </span>
                    <div class="min-w-0 flex-grow-1">
                      <div class="fw-semibold small">Upcoming Events</div>
                      <div v-if="upcoming_events.length > 0" class="text-muted custom-font text-truncate">
                        {{ upcoming_events[0].event_name }} - {{ upcoming_events[0].start_date }}
                      </div>
                      <div v-else class="text-muted custom-font">No upcoming events</div>
                    </div>
                    <span class="fw-bold align-self-center">{{ upcoming_events.length }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h6 class="dashboard-section-title mb-2">Workspace Status</h6>
          <div class="row g-2 g-sm-3">
            <div class="col-6">
              <div class="card border rounded-4 shadow-sm h-100 cursor-pointer" @click="go_to_page('/drive')">
                <div class="card-body p-3">
                  <div class="text-uppercase text-muted fw-bold dashboard-kicker mb-2">Storage</div>
                  <div class="h4 fw-bold mb-0">{{ used_gb || 0 }} GB</div>
                  <div class="text-muted custom-font mb-2">of {{ total_gb || 5 }} GB used</div>
                  <div class="progress progress-storage">
                    <div
                      class="progress-bar bg-dark storage-bar"
                      role="progressbar"
                      ref="storage_progress_bar"
                      :aria-valuenow="percentage_used || 0"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div class="text-muted custom-font mt-2">{{ available_gb || 0 }} GB available</div>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="card border rounded-4 shadow-sm h-100">
                <div class="card-body p-3">
                  <div class="text-uppercase text-muted fw-bold dashboard-kicker mb-2">System</div>
                  <div class="d-flex align-items-center gap-2 fw-semibold text-success small mb-3">
                    <i class="fa-solid fa-circle"></i>
                    All Good
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="custom-font text-muted">Performance</span>
                    <span class="custom-font fw-bold">98%</span>
                  </div>
                  <div class="progress performance-bar mb-2">
                    <div class="progress-bar bg-success w-100"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="custom-font text-muted">Uptime</span>
                    <span class="custom-font fw-bold">99.9%</span>
                  </div>
                  <div class="progress performance-bar">
                    <div class="progress-bar bg-dark w-100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="card border rounded-4 shadow-sm d-none">
            <div class="card-body p-3">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="fw-bold mb-0">My Activity Log</h6>
                <i class="fa-solid fa-history"></i>
              </div>

              <div v-if="audits_loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading activity...</span>
                </div>
                <p class="text-muted small mt-2">Loading your activity log...</p>
              </div>

              <div v-else-if="!has_audit_permission" class="text-center py-5">
                <i class="fa-solid fa-lock text-muted fa-2x mb-3"></i>
                <p class="text-muted mb-0">No permission to view activity log</p>
              </div>

              <div v-else-if="!audits || audits.length === 0" class="text-center py-5">
                <i class="fa-solid fa-history text-muted fa-2x mb-3"></i>
                <p class="text-muted mb-0">No recent activity</p>
              </div>

              <div v-else class="table-responsive dashboard-activity-log">
                <table class="table table-hover align-middle mb-0 dashboard-activity-table">
                  <thead class="table-light">
                    <tr>
                      <th class="border-0 small">Action</th>
                      <th class="border-0 small">Timestamp</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(log, idx) in recent_from_audits" :key="idx" class="dashboard-activity-row">
                      <td class="dashboard-activity-action-cell">
                        <div class="d-flex align-items-center gap-3">
                          <div class="activity-chip d-inline-flex align-items-center justify-content-center">
                            <img src="@/assets/aicone.png" class="img-fluid w-50 h-75" alt="" />
                          </div>
                          <span class="small dashboard-activity-message">{{ log.d }}</span>
                        </div>
                      </td>
                      <td class="text-muted small dashboard-activity-time">{{ log.t }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>

  <transition name="slide-left">
    <div v-if="ai_open" class="kubiki-panel position-fixed end-0 d-flex flex-column shadow-lg">
      <div class="d-flex align-items-center justify-content-between p-3 border-bottom">
        <div class="d-flex align-items-center gap-2">
          <i class="fa-solid fa-cpu"></i>
          <span class="fw-semibold">Kubiki AI Assistant</span>
        </div>
        <button class="btn btn-link text-dark" @click="ai_open = false">x</button>
      </div>

      <div class="p-3">
        <p class="small text-muted mb-2">Ask things like:</p>
        <ul class="small ps-3">
          <li>"Generate a compliance report from Proba for Chris Hani Municipality."</li>
          <li>"Show KYC workflows pending approval in ComplyOn."</li>
          <li>"Summarize the last 24h audit events across all apps."</li>
        </ul>

        <div class="mt-3">
          <input class="form-control rounded-3" placeholder="Type a command..." />
          <div class="d-flex gap-2 mt-2">
            <button class="btn upload-button rounded-3">Run</button>
            <button class="btn upload-button rounded-3">Suggest</button>
          </div>
        </div>
      </div>

      <div class="mt-auto p-3 border-top xxs text-muted">
        You are signed in as <span class="fw-semibold text-dark">{{ user.name }}</span>
      </div>
    </div>
  </transition>
</div>
